<h3>
  <app-fly-to [lngLat]="[vertex.longitude, vertex.latitude]">
    {{vertex.vertex_class}} <strong *ngIf="editionMode">{{vertex.id}}</strong>
  </app-fly-to>
</h3>

<app-loading *ngIf="isLoading"></app-loading>

<ng-container *ngIf="formVertex">

  <section *ngIf="vertex.vertex_class === 'PL'">

    <form [formGroup]="formVertex" class="app-form">
      <mat-form-field appearance="outline" class="app-block">
        <mat-label i18n>Model</mat-label>
        <mat-select formControlName="model">
          <mat-option *ngFor="let value of MODELS" [value]="value">{{value | translation: MODELS_MAPPER}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="app-block">
        <mat-label i18n>Height</mat-label>
        <input matInput type="number" formControlName="height">
        <span matSuffix i18n>meters</span>
      </mat-form-field>
      <mat-form-field appearance="outline" class="app-block">
        <mat-label i18n>Weight</mat-label>
        <input matInput type="number" formControlName="weight">
        <span matSuffix>Kgf</span>
      </mat-form-field>
      <mat-form-field appearance="outline" class="app-block">
        <mat-label i18n>Comments</mat-label>
        <textarea matInput formControlName="comments"></textarea>
      </mat-form-field>
      <h4 i18n>Equipments</h4>
      <mat-checkbox class="app-block" formControlName="has_switch" i18n>Has Switch</mat-checkbox>
      <mat-checkbox class="app-block" formControlName="has_transformer" i18n>Has Transformer</mat-checkbox>
    </form>
  </section>
  <section *ngIf="vertex.vertex_class !== 'PL'">
    <form [formGroup]="formVertex" class="app-form">
      <mat-form-field appearance="outline" class="app-block">
        <mat-label i18n>Comments</mat-label>
        <textarea matInput formControlName="comments"></textarea>
      </mat-form-field>
    </form>
  </section>
  <mat-action-row>
    <button mat-stroked-button color="warn" *ngIf="editionMode" (click)="remove()">
      <span *ngIf="removeConfirmated else removeBlock" i18n>CONFIRM?</span>
    </button>

    <button mat-raised-button [disabled]="!formVertex.valid" (click)="save()" i18n>SAVE</button>
  </mat-action-row>
</ng-container>

<ng-template #removeBlock i18n>REMOVE</ng-template>
